import type { common as commonEn } from "../../en/webHints/common";

// Společné fráze nápověd polí a odkazů „Zobrazit na webu“ (řez 10, F9.6). Klíče zmrazil
// kontrakt řezu; FieldHint a TabWebLink je skládají s texty editorů.
export const common: typeof commonEn = {
  webPrefix: "Na webu:",
  backofficePrefix: "Nezobrazuje se na webu, slouží pro",
  viewOnWeb: "Zobrazit na webu",
  notPublished: "obsah není publikovaný",
  notSavedYet: "po uložení a publikaci",
  tabBackoffice: "Obsah záložky se na webu nezobrazuje, slouží pro {{purpose}}.",
};
